/** @jsx h */

import { h } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';

import Popup from '../Popup';

import styles from './index.scss';

const JoWarningPopup = ({ onClose, onConfirm }) => (
    <Popup onClose={onClose} heading="Are you sure you wish to close the conversation?">
        <p>
            You will lose all your progress with JO and will have to start over if you decide to
            come back.
        </p>
        <div className={styles.buttonWrapper}>
            <button onClick={onConfirm}>Yes, please close JO</button>
        </div>
    </Popup>
);

JoWarningPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default JoWarningPopup;
